module.exports = __webpack_public_path__ + "static/media/wheel-ganbei.4f7db1db.png";